import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'pkp-tso-notice',
    template: require('./tso-notice.component.html')
})
export class TsoNoticeComponent implements AfterViewInit {
    @Input() public title: string;
    @Input() public tsoName: string;
    private _notice: string;
    public needsMoreButton = true;
    @Input() public expanded = true;

    private isInitialized = false;

    @ViewChild('text') textElement: ElementRef<HTMLParagraphElement>;

    get notice(): string {
        return this._notice;
    }

    @Input() set notice(value: string) {
        this._notice = value;
        if (this.isInitialized) {
            this.ngAfterViewInit();
        }
    }

    public ngAfterViewInit(): void {
        this.isInitialized = true;
        this.needsMoreButton =
            this.getInnerHeightOfText() <
            this.textElement.nativeElement.scrollHeight - 1;
    }

    public toggleShow() {
        this.expanded = !this.expanded;
    }

    private getInnerHeightOfText() {
        let styleString = window
            .getComputedStyle(this.textElement.nativeElement, null)
            .getPropertyValue('height');
        return parseInt(styleString.slice(0, styleString.length - 2));
    }
}
